import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-766acd3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "form-content"
}
const _hoisted_2 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Ved login vil brugeren blive bedt om at sætte et nyt password.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_spinner = _resolveComponent("b-spinner")!
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_form_select = _resolveComponent("b-form-select")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_form = _resolveComponent("b-form")!
  const _component_b_offcanvas = _resolveComponent("b-offcanvas")!

  return (_openBlock(), _createBlock(_component_b_offcanvas, {
    modelValue: _ctx.show,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.show) = $event)),
    title: `Opret bruger`
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_b_spinner, { key: 0 }))
        : (!_ctx.userCreated)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_b_form, { onSubmit: _ctx.createUser }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_form_group, { label: "Brugernavn" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_form_input, {
                        modelValue: _ctx.newUser.userName,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newUser.userName) = $event)),
                        type: "text"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_b_form_group, { label: "Navn" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_form_input, {
                        modelValue: _ctx.newUser.name,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newUser.name) = $event)),
                        text: "text"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_b_form_group, { label: "Rolle" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_form_select, {
                        modelValue: _ctx.newUser.role,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newUser.role) = $event)),
                        options: _ctx.roleOptions
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _: 1
                  }),
                  (_ctx.error)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.error), 1))
                    : _createCommentVNode("", true),
                  _createVNode(_component_b_button, {
                    class: "submit-button",
                    size: "lg",
                    type: "submit",
                    variant: "success"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Opret")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onSubmit"])
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("p", null, [
                _createTextVNode("Brugeren "),
                _createElementVNode("strong", null, _toDisplayString(_ctx.newUser?.userName), 1),
                _createTextVNode(" er nu oprettet. ved første login skal brugeren benytte dette password:")
              ]),
              _createElementVNode("p", null, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.initialPassword), 1)
              ]),
              _hoisted_3,
              _createVNode(_component_b_button, {
                class: "submit-button",
                size: "lg",
                type: "submit",
                variant: "success",
                onClick: _ctx.close
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Forstået")
                ]),
                _: 1
              }, 8, ["onClick"])
            ], 64))
    ]),
    _: 1
  }, 8, ["modelValue"]))
}